<template>
    <div class="neue fsp20 lh28 text-black d-flex justify-content-between align-items-center" :class="{ 'mb32': this.isMobile, 'mb16': !this.isMobile }">
        <div v-if="this.isMobile">
            <Icon name="arrow-left" class="c24 pointer" @click="this.close()"/>
        </div>
        <div class="flex-grow-1 fsp20 lh28" :class="{ 'text-center mr24': this.isMobile }">
            {{ this.stage === 'confirm' ? 'Proof of Ownership' : 'Add Address' }}
        </div>
        <div v-if="!this.isMobile">
            <Icon name="close" class="c24 pointer" @click="this.close()"/>
        </div>
    </div>
    <div class="text-black bg-white rounded12" :class="{ 'p-0': this.isMobile, 'p24': !this.isMobile }" v-if="this.stage == 'create'">
        <div class="mb24">
            <label class="fsp14 lh20 text-black mb8">Select Network</label>
            <SelectSimple
                id="form"
                :placeholder="'Select network (e.g., Bitcoin, Ethereum)'"
                :dataValue="this.formData.form"
                :keywords.sync="this.networkOptions"
                :currsP2P="true"
                :isSearch="true"
                @updateParentState="this.updateState"
            />
        </div>
        <div class="mb24">
            <label class="fsp14 lh20 text-black mb8">Address</label>
            <InputSimple
                id="address"
                :placeholder="'Enter wallet address'"
                :dataValue="this.formData.address"
                @updateParentState="this.updateState"
            />
        </div>
        <div class="mb24">
            <label class="fsp14 lh20 text-black mb8">Wallet Name</label>
            <InputSimple
                id="name"
                :placeholder="'Enter wallet name'"
                :dataValue="this.formData.name"
                @updateParentState="this.updateState"
            />
        </div>
        <div class="mb24">
            <label class="fsp14 lh20 text-black mb8">Address Type</label>
            <SelectSimple
                id="ownership"
                :placeholder="'Select address type'"
                :dataValue="this.formData.ownership"
                :keywords.sync="this.ownershipOptions"
                @updateParentState="this.updateState"
            />
        </div>
        <div class="mb24">
            <label class="fsp14 lh20 text-black mb8">Recipient Type</label>
            <SelectSimple
                id="user_type"
                :placeholder="'Select recipient type'"
                :dataValue="this.formData.user_type"
                :keywords.sync="this.userTypeOptions"
                @updateParentState="this.updateState"
            />
        </div>
        <GetInputs
            class="mb24"
            v-if="this.ownershipForm.length > 0"
            :fields="this.ownershipForm"
            :onAlias="true"
            :dataValues="this.ownershipFormFields"
            @updateParentState="this.updateOwnershipFormState"
        />
        <div class="d-flex align-items-center w-100" :class="{ 'position-fixed bottom-0 left-0 end-0 py16 px24 w-100 border-t bg-white': this.isMobile }">
            <Button type="btn-outline-grey" class="equal-width h48 primary-grey mr16" @click="this.close()">Cancel</Button>
            <Button type="btn-warning" class="equal-width h48" @click="this.save()" :disabled="!this.isFormValid">Add Address</Button>
        </div>
    </div>

    <!-- Confirmation Stage -->
    <div class="text-black bg-white rounded12" :class="{ 'p-0': this.isMobile, 'p24': !this.isMobile }" v-if="this.stage == 'confirm'">
        <div class="mb24">
            <label class="fsp14 lh20 text-black mb8">Select Network</label>
            <SelectSimple
                id="form_disabled"
                :placeholder="'Select network (e.g., Bitcoin, Ethereum)'"
                :dataValue="this.formData.form"
                :keywords.sync="this.networkOptions"
                :currsP2P="true"
                :isSearch="true"
                :disable="true"
                @updateParentState="() => {}"
            />
        </div>
        
        <div class="mb24">
            <label class="fsp14 lh20 text-black mb8">Address</label>
            <InputSimple
                id="address_disabled"
                :placeholder="'Enter wallet address'"
                :dataValue="this.formData.address"
                :disabled="true"
                @updateParentState="() => {}"
            />
        </div>
        
        <div class="mb24">
            <label class="fsp14 lh20 text-black mb8">Wallet Name</label>
            <InputSimple
                id="name_disabled"
                :placeholder="'Enter wallet name'"
                :dataValue="this.formData.name"
                :disabled="true"
                @updateParentState="() => {}"
            />
        </div>
        
        <div class="mb24">
            <label class="fsp14 lh20 text-black mb8">Message</label>
            <div class="position-relative message-textarea">
                <InputSimple
                    id="signatureMessage"
                    :placeholder="'Enter message to sign'"
                    :dataValue="this.signatureMessage"
                    :type="'textarea'"
                    :rows="3"
                    @updateParentState="this.updateMessageState"
                />
                <Button 
                    type="btn-outline-primary" 
                    class="position-absolute top-0 end-0 mt8 mr8 px12 py4 fsp12"
                    @click="this.copyMessage()"
                >
                    Copy
                </Button>
            </div>
        </div>
        
        <div class="mb24 p16 bg-light rounded8">
            <div class="fsp14 text-black mb16">
                <div class="mb8">1. Откройте кошелёк</div>
                <div class="mb8">2. Перейдите в <span class="text-primary text-decoration-underline pointer">Sign Message</span></div>
                <div class="mb8">3. Вставьте <span class="text-primary text-decoration-underline pointer">message</span></div>
                <div class="mb8">4. Подпишите и скопируйте <span class="text-primary text-decoration-underline pointer">signature</span></div>
                <div>5. Вставьте signature в форму</div>
            </div>
        </div>
        
        <div class="mb24">
            <label class="fsp14 lh20 text-black mb8">Signature</label>
            <InputSimple
                id="signature"
                :placeholder="'Enter Signature'"
                :dataValue="this.userSignature"
                @updateParentState="this.updateSignatureState"
            />
        </div>
        
        <div class="d-flex align-items-center w-100" :class="{ 'position-fixed bottom-0 left-0 end-0 py16 px24 w-100 border-t bg-white': this.isMobile }">
            <Button type="btn-outline-grey" class="equal-width h48 primary-grey mr16" @click="this.goBack()">Back</Button>
            <Button type="btn-primary" class="equal-width h48" @click="this.verifySignature()" :disabled="!this.userSignature">Verify Signature</Button>
        </div>
    </div>
    
</template>
<script>
import Button from '@/components/service/Button.vue';
import InputSimple from '@/components/service/InputSimple.vue';
import SelectSimple from '@/components/service/SelectSimple.vue';
import GetInputs from '@/components/service/GetInputs.vue';
import Icon from '@/components/icons/Icon.vue';
export default {
    name: 'AddOwnershipAddress',
    components: {
        Button,
        InputSimple,
        SelectSimple,
        GetInputs,
        Icon
    },
    props: {
        close: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            formData: {
                form: '',
                name: '',
                address: '',
                ownership: '',
                user_type: ''
            },
            stage: 'create',
            ownershipForm: [],
            ownershipFormFields: {},
            signatureForm: [],
            confirmationData: {
                network: '',
                address: '',
                walletName: ''
            },
            signatureMessage: '',
            userSignature: '',
            ownershipOptions: [
                { code: 'custodian', value: 'Custodian' },
                { code: 'selfhosted_mine', value: 'Selfhosted Mine' },
                { code: 'selfhosted_3dparty', value: 'Selfhosted 3rd Party' },
                { code: 'selfhosted_unknown', value: 'Selfhosted Unknown' },
                { code: 'not_found', value: 'Not Found' }
            ],
            userTypeOptions: [
                { code: 'personal', name: 'Физическое лицо' },
                { code: 'legal', name: 'Юридическое лицо' }
            ],
            networkOptions: []
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        },
        isFormValid() {
            return this.formData.form && 
                   this.formData.name && 
                   this.formData.address && 
                   this.formData.ownership;
        }
    },
    created() {
        this.getNetworks();
        this.getOwnershipForm();
    },
    methods: {
        updateState(state) {
            if (state.id === 'ownership') {
                const ownershipOption = this.ownershipOptions.find(opt => opt.code === state.value);
                this.getOwnershipFormFields(state.value);
                this.formData[state.id] = ownershipOption.description;
            } else {
                this.formData[state.id] = state.value;
            }
        },
        updateOwnershipFormState(state) {
            this.ownershipFormFields[state.id] = state.value;
        },
        updateSignatureState(state) {
            this.userSignature = state.value;
        },
        updateMessageState(state) {
            this.signatureMessage = state.value;
        },
        getNetworks() {
            this.axios.post('GetSearchMomental', {
                data: {
                    form_type: '70'
                }
            }).then(res => {
                if (res.data.body.result !== '0') {
                    return;
                }
                this.networkOptions = this.convertkeywords(res.data.body.tables[0]['colvalues']);
            });
        },
        getOwnershipForm() {
            this.axios.post('GetSearchMomental', {
                data: {
                    form_type: '71'
                }
            }).then(res => {
                if (res.data.body.result !== '0') {
                    return;
                }
                let f = res.data.body.tables[0]['colvalues'];
                this.ownershipOptions = f.map(e => {return {'code': e.code, value: e.name, description: e.description}});
            });
        },
        getOwnershipFormFields(arg) {
            this.axios.post('GetFormFields', {
                full: true,
                data: {
                    payform: arg
                }
            }).then(res => {
                if (res.data.body.result !== '0' && res.data.body.tables[0]['colvalues'].length < 1) {
                    return;
                }
                this.ownershipForm = res.data.body.tables[0]['colvalues'];
                this.ownershipForm.forEach(field => {
                    if (field.alias) {
                        this.ownershipFormFields[field.alias] = '';
                    }
                });
            });
        },
        convertkeywords(arg) {
            return arg.map(item => {
                return {
                    code: item.code,
                    name: item.name,
                    full_name: item.name,
                    logo: item.img || item.icon || item.logo || item.image,
                    small_name: item.small_name || item.code,
                    curr_text: item.curr_text || item.code,
                    unit_abbreviation: item.unit_abbreviation || item.code
                }
            });
        },
        save() {
            if (!this.isFormValid) {
                return;
            }
            
            const data = {
                form: this.formData.form,
                address: this.formData.address,
                name: this.formData.name,
                ownership: this.formData.ownership,
                user_type: this.formData.user_type,
                user_fields: this.ownershipFormFields
            };

            // Добавляем динамические поля из ownershipFormFields
            // if (Object.keys(this.ownershipFormFields).length > 0) {
            //     Object.assign(data, this.ownershipFormFields);
            // }

            this.axios.post('CreateCryptoAddress', {
                data: data
            }).then(res => {
                if (res.data.body && res.data.body.result != '0') {
                    return;
                }
                this.axios.post('GetCryptoAddress', {data: {address: this.formData.address}}).then(res => {
                    if (res.data.body.result != '0') {
                        return;
                    }
                    if (!res.data.body.tables?.['ownerships']?.['colvalues']?.[0]?.['source_info']?.['form']) {
                        return;
                    }
                    let msform = res.data.body.tables?.['ownerships']?.['colvalues']?.[0]?.['source_info']?.['form'];
                    this.confirmationData = {
                        network: this.networkOptions.find(n => n.code === this.formData.form)?.name || this.formData.form,
                        address: this.formData.address,
                        walletName: this.formData.name
                    };
                    this.axios.post('GetFormFields', {
                        full: true,
                        data: {
                            payform: msform
                        }
                    }).then(res => {
                        if (res.data.body.result != '0') {
                            return;
                        }
                        this.signatureForm = res.data.body.tables?.['0']?.['colvalues'];
                    })
                    this.axios.post('GetOwnershipMessage', {
                        data: {
                            address: this.formData.address
                        }
                    }).then(res => {
                        if (res.data.body.result != '0') {
                            return;
                        }
                        this.signatureMessage = res.data.body.tables?.['ownerships']?.['colvalues']?.[0]?.['message'];
                        this.stage = 'confirm';
                    })
                });
            });
        },
        copyMessage() {
            navigator.clipboard.writeText(this.signatureMessage).then(() => {
                // Можно добавить уведомление об успешном копировании
                console.log('Message copied to clipboard');
            });
        },
        goBack() {
            this.stage = 'create';
        },
        verifySignature() {
            if (!this.userSignature) {
                return;
            }
            
            // Здесь можно добавить API вызов для верификации подписи
            // После успешной верификации вызываем callback и закрываем модал
            if (this.$store.state.modal.content.callback) {
                this.$store.state.modal.content.callback();
            }
            this.close();
        }
    }
}
</script>
<style lang="scss" scoped>
.equal-width {
    flex: 1;
}

.message-textarea {
    :deep(textarea) {
        padding-right: 90px !important;
        box-sizing: border-box !important;
    }
    :deep(.form-control) {
        padding-right: 90px !important;
    }
}
</style>
